import React from "react";

export default function ChatMessageList({ messages, myUserId, bottomRef }) {
  const formatDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleString("fr-FR", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  return (
    <div className="flex-1 overflow-y-auto p-4">
      {messages.map((m, i) => {
        const senderId = m.senderUserId || m.SenderUserId;
        const senderName = m.senderName || m.SenderName || "Utilisateur";
        const timestamp = m.timestamp || m.Timestamp;

        const isMine = senderId === myUserId;

        return (
          <div
            key={m.id || i}
            className={`flex mb-3 ${isMine ? "justify-end" : "justify-start"}`}
          >
            {!isMine && (
              <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center text-sm mr-2">
                {senderName[0] ?? "?"}
              </div>
            )}

            <div
              className={`px-3 py-2 rounded-xl max-w-[70%] shadow ${
                isMine ? "bg-blue-600 text-white" : "bg-white border"
              }`}
            >
              {!isMine && (
                <div className="font-semibold text-sm mb-1">{senderName}</div>
              )}

              <div>{m.content || m.Content}</div>

              <div className="text-xs opacity-70 mt-1 text-right">
                {formatDate(timestamp)}
              </div>
            </div>
          </div>
        );
      })}

      <div ref={bottomRef}></div>
    </div>
  );
}
